export default __webpack_public_path__ + "static/media/industrytop.0a46b414.png";